module.exports = __webpack_public_path__ + "static/media/kepler.0b71582d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/kepler.JPG
// module id = 262
// module chunks = 0